export type FaqItem = { q: string; a: string };

export const platformFaqs: FaqItem[] = [
  {
    q: "What is the Perceptica Media Listening Platform?",
    a: "MLP 2.0 is our professional media intelligence command centre. It captures mentions across online news, social, blogs and newspapers, then turns them into interactive dashboards, alerts and reports so you can see what's happening to your brand in real time.",
  },
  {
    q: "Which media types does it cover?",
    a: "Online news, social media, blogs and traditional newspapers - across 25+ languages and the markets that matter to you.",
  },
  {
    q: "Does it support sentiment analysis?",
    a: "Yes. Every result is automatically classified as Positive, Neutral or Negative so you can track reputation shifts and spot potential crises early.",
  },
  {
    q: "Can I get real-time alerts?",
    a: "Yes - new mention alerts, volume change alerts (percentage spikes or numerical thresholds) and refinement controls by sentiment, media type or country. Delivered as they happen, daily or weekly.",
  },
  {
    q: "Can I export reports and charts?",
    a: "Yes. Raw data and visual charts can be exported in CSV, Excel, PDF, PNG or JPG for use in internal presentations or third-party tools.",
  },
  {
    q: "Can stakeholders receive scheduled newsletters?",
    a: "Yes. Schedule recurring daily, weekly or monthly briefings that deliver the latest results from your selected searches straight to stakeholders' inboxes.",
  },
  {
    q: "Is the data interactive - can I drill down?",
    a: "Every chart is fully interactive. Click any segment of a chart to instantly view the specific articles behind the data.",
  },
  {
    q: "Can I tag and filter results?",
    a: "Yes. Apply your own custom tags across multiple searches, then filter by Country, Region, Author, Publisher or Media Type to surface the exact intelligence you need.",
  },
  {
    q: "How do I get access?",
    a: "Book a personalised demo and our team will walk you through the platform with your brand, competitors and topics already loaded in.",
  },
];

export const mediaAnalysisFaqsBg: FaqItem[] = [
  {
    q: "Какво представлява медийният анализ на Perceptica?",
    a: "Медийният анализ е експертна услуга, която превръща суровите медийни сигнали в информация, готова за вземане на решения. Старши анализатори интерпретират данните и предоставят изводи, препоръки и стратегически насоки, върху които можете да действате.",
  },
  {
    q: "Какви видове анализ предлагате?",
    a: "Предлагаме пет основни програми: анализ на репутацията, конкурентно разузнаване, мониторинг и анализ при кризи, пазарни проучвания и анализ на работодателския бранд. Всяка от тях може да бъде реализирана като еднократен проект или като текуща програма.",
  },
  {
    q: "Кой извършва анализа?",
    a: "Анализите се изготвят от старши многоезични анализатори, които съчетават опит в медийния анализ със задълбочено познаване на съответната индустрия. Получавате конкретен екип, който познава вашите цели и контекст.",
  },
  {
    q: "Кои езици и пазари покривате?",
    a: "Работим на над 25 езика и покриваме европейски и глобални пазари. Ако оперирате на пазар, който все още не е включен, можем да обсъдим възможност за добавянето му.",
  },
  {
    q: "В какви формати се предоставят резултатите?",
    a: "Резултатите могат да бъдат представени като PDF отчети, PowerPoint презентации, интерактивни дашборди, управленски брифинги и специализирани материали за бордове, инвеститори и други заинтересовани страни.",
  },
  {
    q: "Колко продължава един типичен ангажимент?",
    a: "Тактическите анализи могат да бъдат готови в рамките на няколко дни. По-дългосрочните програми за репутация или конкурентен анализ следват фиксиран месечен или тримесечен ритъм. При кризи можем да започнем работа в рамките на часове.",
  },
  {
    q: "По какво се различава тази услуга от платформата за медиен мониторинг?",
    a: "Платформата предоставя данните, визуализациите и автоматичните сигнали. Медийният анализ добавя експертен човешки слой - контекст, интерпретация, препоръки и стратегически изводи. Повечето клиенти използват и двете решения заедно.",
  },
  {
    q: "Предлагате ли еднократни проекти и дългосрочни програми?",
    a: "Да. Работим както по еднократни анализи и стратегически проучвания, така и по дългосрочни програми за репутация, конкурентно разузнаване и кризисен мониторинг.",
  },
  {
    q: "Подписвате ли NDA при чувствителни проекти?",
    a: "Да. Подписването на споразумения за поверителност е стандартна практика при кризисни, конкурентни, инвестиционни и M&A проекти.",
  },
  {
    q: "Как да започна?",
    a: "Заявете демо или разговор за уточняване на обхвата. Ще обсъдим вашите цели, ще препоръчаме най-подходящия тип анализ и ще подготвим персонализирано предложение.",
  },
];

export const platformFaqsBg: FaqItem[] = [
  {
    q: "Какво представлява платформата за медиен мониторинг на Perceptica?",
    a: "Платформата за медиен мониторинг на Perceptica проследява публикации в онлайн медии, социални мрежи, блогове и печатни издания и ги превръща в анализи, дашборди, сигнали и отчети. Така получавате ясна представа за присъствието и репутацията на вашия бранд в реално време.",
  },
  {
    q: "Какви източници и медийни канали покрива платформата?",
    a: "Платформата обхваща онлайн новини, социални мрежи, блогове и традиционни печатни издания на над 25 езика и в пазарите, които са важни за вашата организация.",
  },
  {
    q: "Поддържа ли платформата анализ на тоналността?",
    a: "Да. Всеки резултат се класифицира автоматично като позитивен, неутрален или негативен, за да можете да следите промените в репутацията и да откривате потенциални кризи навреме.",
  },
  {
    q: "Мога ли да получавам сигнали в реално време?",
    a: "Да. Можете да настройвате сигнали за нови споменавания, за рязка промяна в обема на публикациите и за конкретни условия по тоналност, тип медия или държава. Известията могат да се получават незабавно, ежедневно или седмично.",
  },
  {
    q: "Мога ли да експортирам данни, отчети и графики?",
    a: "Да. Данните и визуализациите могат да бъдат експортирани в CSV, Excel, PDF, PNG или JPG за използване във вътрешни презентации, доклади и външни инструменти.",
  },
];

export const mediaAnalysisFaqs: FaqItem[] = [
  {
    q: "What is Media Analysis at Perceptica?",
    a: "Media Analysis is our human-led service that turns raw media signals into decision-ready intelligence. Senior analysts interpret the data behind your coverage and deliver findings, recommendations and narratives you can act on.",
  },
  {
    q: "What types of analysis do you offer?",
    a: "Five tailored programmes: Reputation Analysis, Competitive Intelligence, Crisis Monitoring & Analysis, Market Research and Employer Branding Analysis. Each can be run as a one-off project or an ongoing programme.",
  },
  {
    q: "Who delivers the analysis?",
    a: "Senior, multilingual analysts who combine media expertise with domain knowledge of your sector. You get a named team, not an anonymous queue.",
  },
  {
    q: "Which languages and markets do you cover?",
    a: "25+ languages across European and global markets. If you operate in a market we don't already cover, talk to us - we routinely scope new ones.",
  },
  {
    q: "What deliverable formats can I get?",
    a: "PDF reports, PowerPoint decks, live dashboards, executive briefings and bespoke formats for board or investor audiences. We adapt to how your stakeholders consume information.",
  },
  {
    q: "How long does a typical engagement take?",
    a: "Tactical reports turn around in days. Quarterly reputation or competitive programmes run on a fixed cadence. Crisis work is on-demand and can begin within hours.",
  },
  {
    q: "How is this different from the Media Listening Platform?",
    a: "The platform gives you the data and dashboards. Media Analysis is the senior human layer on top - context, interpretation, recommendations and narrative. Most clients use both.",
  },
  {
    q: "Can you handle one-off projects as well as ongoing programmes?",
    a: "Yes. We deliver everything from a single market-research deep-dive to multi-year reputation and crisis programmes.",
  },
  {
    q: "Do you sign NDAs for sensitive crisis or M&A work?",
    a: "Yes. Confidentiality and NDAs are standard for crisis, competitive and M&A engagements.",
  },
  {
    q: "How do I start?",
    a: "Request a demo or scoping call. We will discuss your objectives, recommend the right analysis type and propose a tailored programme.",
  },
];
